export const ICON_PATH: string = "/assets/icon/"

interface MessageItemFace {
    code: string
    icon: string
    title: string
    url: string
}

export const MessageItems:MessageItemFace[] = [
    {code:"news", icon: ICON_PATH+"news_fill.svg", title:"校内通知", url:"/news/school"},
    {code:"class", icon: ICON_PATH+"campus-video-type.svg", title:"班级通知", url:"/news/class"},
    {code:"person", icon: ICON_PATH+"person.svg", title:"个人通知", url:"/news/person"}
]

export const ToolBar:any = {
    height: 3
}

export const Header:any = {
    height: 0,
}

export const Content: any = {
    top: -(Header.height>0 ? Header.height/4 : ToolBar.height)
}